export function getOrAddEntry<TKey extends string | number | symbol, TEntry>(
	key: TKey,
	record: Record<TKey, TEntry>,
	factory: (key: TKey) => TEntry
): TEntry {
	let entity = record[ key ];

	if (!entity) {
		entity = factory(key);

		record[ key ] = entity;
	}

	return entity;
}

export function objectKeys<T extends object>(obj: T): Array<keyof T> {
	return Object.keys(obj) as Array<keyof T>;
}
